import space from '@styled-system/space'
import typography from '@styled-system/typography'
import { em } from 'polished'
import styled from 'styled-components'
import { H4 } from 'styles/components/typography'

import DynamicImage from 'components/DynamicImage'
import { BoxBase, Col } from 'styles/components/layout'

const threshold = '768px'

export const BoxBaseStyled = styled(BoxBase)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  padding: 0;
  background: ${p => p.theme.colors.catskillWhite};
  @media (min-width: ${threshold}) {
    flex-direction: row;
    padding: 0;
  }
`

export const ColStyled = styled(Col)`
  position: relative;
  ${space};
  ${typography};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ColCentered = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: ${em(40)};
  padding-right: ${em(40)};
  @media (min-width: ${threshold}) {
    background: ${p => p.theme.colors.white};
    padding-bottom: 0;
  }
`

export const ImageWrapper = styled('div')`
  position: relative;
`

export const DynamicImageStyled = styled(DynamicImage)`
  padding-top: ${em(20)};
  padding-bottom: ${em(20)};
  max-width: ${em(350)};
  margin: 0 auto;
  cursor: pointer;

  ${p => p.theme.mq.upMd} {
    height: inherit;
    object-position: left top;
    max-width: initial;
    margin: 0;
  }
  @media (min-width: ${threshold}) {
    padding-left: ${em(40)};
  }
`

export const DynamicImageMobile = styled(DynamicImageStyled)`
  @media (min-width: ${threshold}) {
    display: none;
  }
`

export const DynamicImageDesktop = styled(DynamicImageStyled)`
  padding-bottom: ${em(80)};
  padding-top: ${em(80)};
  padding-right: ${em(20)};
  display: none;
  @media (min-width: ${threshold}) {
    display: block;
  }
`

export const VideoWrapper = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IframeStyled = styled('iframe')`
  position: relative;
  height: 50vw;
  width: 90%;
`

export const ExitArea = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export const ButtonWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10%;
  @media (min-width: ${threshold}) {
    padding: 6% 0 0 2%;
  }
`

export const H4Mobile = styled(H4)`
  padding-left: ${em(10)};
  padding-top: ${em(40)};
  @media (min-width: ${threshold}) {
    display: none;
  }
`

export const H4Desktop = styled(H4)`
  display: none;
  @media (min-width: ${threshold}) {
    display: block;
  }
`

export const TextWrapper = styled('div')`
  padding: ${em(10)};
  @media (min-width: ${threshold}) {
    padding: ${em(40)};
  }
`
